import { CircularProgress, Grid, MenuItem, Paper } from "@material-ui/core";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CancelIcon from '@mui/icons-material/Cancel';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { Autocomplete, Button, Input, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Tooltip from "@mui/material/Tooltip";
import { Controller } from "react-hook-form";
import { calculateSettlementTotals, SectionTitle, StyledTableCell, StyledTableRow } from "./SettlementDetailsShared";

let genderList = [{id:"MALE",label:"MALE"},{id:"FEMALE",label:"FEMALE"},{id:"OTHER",label:"OTHER"}] ;

const InvestorInformationSection = ({
  BOIDError,
  bankList,
  branchList,
  genderError,
  canUserActOnStatus,
  claimentNidError,
  control,
  copiedAccount,
  copiedBO,
  copiedMobile,
  data,
  emailError,
  enableEdit,
  getBranchList,
  handleChangeUpdatedData,
  handleCopyAccount,
  handleCopyBO,
  handleCopyMobile,
  handleEditOpen,
  handleUpdateChange,
  mobileError,
  nidError,
  previousData,
  selectedBank,
  selectedBranch,
  setBOIDError,
  setBranchList,
  setData,
  setEmailError,
  setEnableEdit,
  setMobileError,
  setNidError,
  setSelectedBank,
  setSelectedBranch,
  setTinError,
  setUpdatedData,
  setclaimentNidError,
  setsHoldernidError,
  sHoldernidError,
  tinError,
  updateInProgress,
}) => (        <Grid item xs={12} md={6}>
          <SectionTitle>Investor Information</SectionTitle>
          <TableContainer component={Paper} sx={{ marginBottom: 1, boxShadow: 0 }}>
            <Table size="small" sx={{ minWidth: 300 }}>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell variant="head">Name :</StyledTableCell>
                  <StyledTableCell>  {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced") ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="name"
                                              value={data.name}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(e) => {handleChangeUpdatedData(e)}}
                                            />
                                          ) 
                                            : 
                                            data.name || "N/A"}
                    </StyledTableCell>
                  <StyledTableCell variant="head">Mobile:</StyledTableCell>
                  <StyledTableCell>
                    {
                      enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back") 
                      ? 
                      (
                          <FormControl fullWidth required variant="standard" size="small">
                              <Input
                                name="mobileNumber"
                                required
                                type="text"
                                value={data.mobileNumber}
                                onChange={(e) => {
                                  let value = e.target.value.replace(/\D/g, "");
                                  if (value.startsWith("0")) {
                                    value = value.slice(1);
                                  }
                                  if (value.length > 10) {
                                    value = value.slice(0, 10);
                                  }
                                  let formattedValue = `${value}`
                                  console.log(formattedValue)
                                  handleChangeUpdatedData(e);
                                  if (value.length !== 10) {
                                    setMobileError("Mobile No. must be 11 digits!");
                                  } else {
                                    setMobileError("");
                                  }
                                }}
                                
                                startAdornment={
                                  <InputAdornment position="start">+880</InputAdornment>
                                }
                                placeholder="1XXXXXXXXX"
                                inputProps={{
                                  maxLength: 10, // restrict typing length
                                }}
                                label="Mobile Number"
                              />
                              {
                                data.mobileNumber === "" 
                                                  ? 
                                                    (
                                                      <span style={{ color: "red",textAlign:"center" }}>Mobile No. required</span>
                                                    ) 
                                                    : 
                                                    mobileError 
                                                    ? 
                                                    (
                                                      <span style={{ color: "red" ,textAlign:"center"}}>{mobileError}</span>
                                                    ) 
                                                    : 
                                                    null
                              }
                          </FormControl>
                        ) 
                       : 
                        (
                        <div style={{ display: "flex", alignItems: "center",justifyContent: "space-between",width: "100%"}}>
                          <span>{data.mobileNumber || "N/A"}</span>

                          {/* Copy button — only if mobile number exists */}
                          {data.mobileNumber && (
                            <Tooltip title={copiedMobile ? "Copied to clipboard!" : "Copy"} placement="top">
                              <IconButton
                                size="small"
                                onClick={handleCopyMobile}
                                style={{ padding: "4px" }}
                              >
                                <ContentCopyIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      )
                      }
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell variant="head">BO ID:</StyledTableCell>
                  <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back") ? (
                                            <TextField
                                                          fullWidth
                                                          variant="standard"
                                                          size="small"
                                                          type="text" 
                                                          name="boID"
                                                          value={data.boID || ""}
                                                          onChange={(e) => {
                                                            let value = e.target.value.replace(/\D/g, "");
                                                            if (value.length > 16) {
                                                              value = value.slice(0, 16);
                                                            }
                                                            handleChangeUpdatedData(e);
                                                            if (value && value.length !== 16) {
                                                              setBOIDError("BOID must be exactly 16 digits");
                                                            } else {
                                                              setBOIDError("");
                                                            }
                                                          }}
                                                          onWheel={(e) => e.target.blur()} 
                                                          onKeyDown={(e) => {
                                                            if (["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(e.key)) {
                                                              e.preventDefault(); 
                                                            }
                                                          }}
                                                          inputProps={{
                                                            inputMode: "numeric", 
                                                            pattern: "\\d*",
                                                            maxLength: 16,
                                                          }}
                                                          error={!!BOIDError}
                                                          helperText={BOIDError && <span style={{ color: "red" }}>{BOIDError}</span>}
                                                        />
                                          ) 
                                            : 
                                            (
                        <div style={{ display: "flex", alignItems: "center",justifyContent: "space-between",width: "100%"}}>
                          <span>{data.boID || "N/A"}</span>

                          {/* Copy button — only if mobile number exists */}
                          {data.boID && (
                            <Tooltip title={copiedBO ? "Copied to clipboard!" : "Copy"} placement="top">
                              <IconButton
                                size="small"
                                onClick={handleCopyBO}
                                style={{ padding: "4px" }}
                              >
                                <ContentCopyIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      )}</StyledTableCell>
                                    <StyledTableCell variant="head">Folio ID:</StyledTableCell>
                                    <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back"|| data.claimStatus === "Bounced") ? (
                                            <TextField 
                                                  name="folioNumber"
                                                  fullWidth 
                                                  variant="standard" 
                                                  type="text"
                                                  value= {data.folioNumber}
                                                  onChange={(e)=>handleChangeUpdatedData(e)}
                                                  
                                            />
                                          ) 
                                            : 
                                            data.folioNumber || "N/A"}</StyledTableCell>
                                      </StyledTableRow>
                                      <StyledTableRow>
                                        <StyledTableCell variant="head">NID:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                              fullWidth
                                              variant="standard"
                                              type="text"
                                              name="nid"
                                              value={data.nid}
                                              onChange={(e) => {
                                                let value = e.target.value.replace(/\D/g, "");
                                                if (value.length > 17) {
                                                  value = value.slice(0, 17);
                                                }
                                                handleChangeUpdatedData(e);
                                                 if (value && ![10, 13, 17].includes(value.length)) {
                                                  setNidError("NID must be 10, 13, or 17 digits");
                                                } else {
                                                  setNidError("");
                                                }
                                              }}
                                              inputProps={{
                                                inputMode: "numeric",
                                                pattern: "\\d*",
                                                maxLength: 17,
                                              }}
                                              error={!!nidError}
                                              helperText={nidError && <span style={{ color: "red" }}>{nidError}</span>}
                                            />
                                          ) 
                                            : 
                                            data.nid || "N/A"}</StyledTableCell>
                                        <StyledTableCell variant="head">Passport:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="passport"
                                              value={data.passport}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(e)=>handleChangeUpdatedData(e)}
                                            />) 
                                            : 
                                            data.passport || "N/A"}</StyledTableCell>
                                    </StyledTableRow>
                                    {
                                      (data.claimType === 2 || data.claimType === 3)  &&(
                                      <StyledTableRow>
                                        <StyledTableCell variant="head">Claimant Name:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced" ) ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="claimentName"
                                              value={data.claimentName}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(e) => {handleChangeUpdatedData(e)}}
                                            />
                                          ) 
                                            : 
                                            data.claimentName || "N/A"}</StyledTableCell>
                                        <StyledTableCell variant="head">Claimant NID:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back"  ) ? (
                                            <TextField
                                              fullWidth
                                              variant="standard"
                                              type="text"
                                              name="claimentNid"
                                              value={data.claimentNid}
                                              onChange={(e) => {
                                                let value = e.target.value.replace(/\D/g, "");
                                                if (value.length > 17) {
                                                  value = value.slice(0, 17);
                                                }
                                                handleChangeUpdatedData(e);
                                                 if (value && ![10, 13, 17].includes(value.length)) {
                                                  setclaimentNidError("NID must be 10, 13, or 17 digits");
                                                } else {
                                                  setclaimentNidError("");
                                                }
                                              }}
                                              inputProps={{
                                                inputMode: "numeric",
                                                pattern: "\\d*",
                                                maxLength: 17,
                                              }}
                                              error={!!claimentNidError}
                                              helperText={claimentNidError && <span style={{ color: "red" }}>{claimentNidError}</span>}
                                            />) 
                                            : 
                                            data.claimentNid || "N/A"}</StyledTableCell>
                                      </StyledTableRow>
                                      )
                                    }
                                    {
                                      data.accountType ===1 && (
                                        <>
                                        <StyledTableRow>
                                        <StyledTableCell variant="head">Second Holder Name:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="sHolderName"
                                              value={data.sHolderName}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(e) => {handleChangeUpdatedData(e)}}
                                            />
                                          ) 
                                            : 
                                            data.sHolderName || "N/A"}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell variant="head">Second Holder NID:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                              fullWidth
                                              variant="standard"
                                              type="text"
                                              name="sHoldernid"
                                              value={data.sHoldernid}
                                              onChange={(e) => {
                                                let value = e.target.value.replace(/\D/g, "");
                                                if (value.length > 17) {
                                                  value = value.slice(0, 17);
                                                }
                                                handleChangeUpdatedData(e);
                                                 if (value && ![10, 13, 17].includes(value.length)) {
                                                  setsHoldernidError("NID must be 10, 13, or 17 digits");
                                                } else {
                                                  setsHoldernidError("");
                                                }
                                              }}
                                              inputProps={{
                                                inputMode: "numeric",
                                                pattern: "\\d*",
                                                maxLength: 17,
                                              }}
                                              error={!!sHoldernidError}
                                              helperText={sHoldernidError && <span style={{ color: "red" }}>{sHoldernidError}</span>}
                                            />
                                          ) 
                                            : 
                                            data.sHoldernid || "N/A"}</StyledTableCell>
                                        <StyledTableCell variant="head">Second Holder Passport:</StyledTableCell>
                                        <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="sHolderPassport"
                                              value={data.sHolderPassport}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(e)=>handleChangeUpdatedData(e)}
                                            />) 
                                            : 
                                            data.sHolderPassport || "N/A"}</StyledTableCell>
                                    </StyledTableRow>
                                        </>
                                      )
                                    }
                                    

                                    <StyledTableRow>
                  <StyledTableCell variant="head">Bank Name:</StyledTableCell>
                  <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced") ? 
                  ( 
                    <>          
                          <Controller
                            name="bankName"
                            control={control}
                            render={({ field }) => {
                              const { onChange } = field;
                              return (
                                <Autocomplete
                                disableClearable
                                  value={selectedBank || null}
                                  options={bankList}
                                  getOptionLabel={(option) => option.bankName || null}
                                  onChange={(event, newValue) => {
                            setSelectedBank(newValue || null);
                            onChange(newValue ? newValue.bankName : "");
                            setData((prev) => ({
                              ...prev,
                              bank: {
                                ...prev.bank,
                                bankName: newValue?.bankName || "",
                                bAccountNo: "",
                              },
                              bAccountNo: "",
                              
                            }));
                            setUpdatedData((prev) => ({
                              ...prev,
                              bankName: newValue?.bankName || "",
                              bankId:null,
                              bAccountNo:null,
                            }));

                            if (newValue) {
                              getBranchList(newValue.bankName);
                              setBranchList([]);
                              setSelectedBranch(null);
                            } else {
                              setBranchList([]);
                              setSelectedBranch(null);
                            }
                          }}

                                  renderInput={(params) => (
                                    <TextField {...params} variant="standard" size="small" />
                                  )}
                                />
                              );
                            }}
                          />
                          {data.bankName === "" && (
                                <span style={{ color: "red" }}>Bank required</span>
                              )}</>
                       ) 
                       : 
                        data.bank?.bankName || "N/A"}</StyledTableCell>
                      <StyledTableCell variant="head">Branch:</StyledTableCell>
                      <StyledTableCell>
                        {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced") ? (
                        <Controller
                          name="bankId"
                          control={control}
                          render={({ field, fieldState: { error } }) => {
                            const { onChange } = field;
                            return (
                              <>
                                <Autocomplete
                                  disableClearable
                                  value={selectedBranch || null}
                                  options={branchList}
                                  getOptionLabel={(option) =>
                                    option?.branchName && option?.routingNo
                                      ? `${option.branchName} (${option.routingNo})`
                                      : ""
                                  }
                                  onChange={(event, newValue) => {
                                    setSelectedBranch(newValue || null);
                                    onChange(newValue?.id || "");

                                    setData((prevState) => ({
                                      ...prevState,
                                      bank: {
                                        ...prevState.bank,
                                        branchName: newValue?.branchName || "",
                                        routingNo: newValue?.routingNo || "",
                                      },
                                    }));
                                    setUpdatedData((prev) => ({
                                      ...prev,
                                      bankId: newValue?.id || "",
                                    }));
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      size="small"
                                      error={!!error}
                                      helperText={error ? error.message : ""}
                                    />
                                  )}
                                />


                              {data.bankId === "" && (
                                <span style={{ color: "red" }}>Branch required</span>
                              )}
                            </>
                          );
                        }}
                      />
                    ) 
                    : 
                    data.bank
                      ? `${data.bank.branchName} (${data.bank.routingNo})`
                      : "N/A"}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell variant="head">A/C Number:</StyledTableCell>
                  <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced") ? (
                                            <TextField
                                              size="small"
                                              fullWidth
                                              variant="standard"  
                                              type="text" 
                                              name="bAccountNo"
                                              value={data.bAccountNo}
                                              style={{textAlign:"center",padding:"0",margin:"0"}}
                                              onChange={(event) => {
                                                handleChangeUpdatedData(event);
                                              }}

                                                
                                            />) 
                                            : 
                                            (
    <div style={{ display: "flex", alignItems: "center",justifyContent: "space-between",width: "100%"}}>
      <span>{data.bAccountNo || "N/A"}</span>

      {/* Copy button — only if account number exists */}
      {data.bAccountNo && (
        <Tooltip title={copiedAccount ? "Copied to clipboard!" : "Copy"} placement="top">
          <IconButton
            size="small"
            onClick={handleCopyAccount}
            style={{ padding: "4px" }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  )}</StyledTableCell>
                  <StyledTableCell variant="head">TIN:</StyledTableCell>
                  <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                                            <TextField
                                                          fullWidth
                                                          variant="standard"
                                                          type="text"
                                                          name="tin"
                                                          value={data.tin}
                                                          onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                              handleChangeUpdatedData(e);
                                                              if (value && value.length !== 12) {
                                                                setTinError("12 Digit TIN No. is required!");
                                                              } else {
                                                                setTinError("");
                                                              }
                                                            }
                                                          }}
                                                          error={!!tinError}
                                                          helperText={tinError}
                                                          inputProps={{ maxLength: 12 }}
                                                        />
                                          ) 
                                            : 
                                            data.tin || "N/A"}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell variant="head">Email:</StyledTableCell>
                  <StyledTableCell>{enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back") ? (
                                            <TextField
                                                fullWidth
                                                variant="standard"
                                                type="email"
                                                name="email"
                                                value={data.email}
                                                style={{ margin: "5px 0", width: "100%" }}
                                                onChange={(event) => {
                                                  const value = event.target.value;
                                                  handleChangeUpdatedData(event);
                                                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                  if (value && !emailRegex.test(value)) {
                                                    setEmailError("Please enter a valid email address");
                                                  } else {
                                                    setEmailError("");
                                                  }
                                                }}
                                                error={!!emailError}
                                                helperText={emailError && <span style={{ color: "red" }}>{emailError}</span>}
                                             />
                                          ) 
                                            : 
                                            data.email || "N/A"}</StyledTableCell>
                  <StyledTableCell variant="head">Gender:</StyledTableCell>
                  <StyledTableCell>
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back") ? (
                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        name="gender"
                        value={data.gender || ""}
                        onChange={(e) => handleChangeUpdatedData(e)}
                        error={!!genderError}
                        helperText={genderError}
                      >
                        {genderList.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.label} 
                        </MenuItem>
                      ))}
                      </TextField>
                    ) 
                    :
                    data.gender ? data.gender || "N/A" : "N/A"}
                  </StyledTableCell>
                  <StyledTableCell>
                    
                  </StyledTableCell>
                </StyledTableRow>
                {
                   canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" || data.claimStatus === "Bounced")
                   ?
                   <StyledTableRow>
                  <StyledTableCell colSpan={4} align="right">
                    {
                      enableEdit
                      ?
                      updateInProgress ?
                      <CircularProgress size={40} style={{ display: "block", margin: "20px auto" }} />
                      :
                      <>
                      <Button variant="contained" color="warning" size="small" style={{marginRight:"5px",padding:"1px 5px",fontSize:"12px"}} onClick={()=>{
                        const settlementDetails = (previousData.settelementDetails || []).map(item => ({
                          ...item,
                          dividendInput: String(Number(item.amount || 0) - Number(item.suspenseAmount || 0)),
                          suspenseInput: String(item.suspenseAmount || 0)
                        }));
                        const totals = calculateSettlementTotals(settlementDetails);

                        setData((prev) => ({ ...prev, ...previousData }));
                        setUpdatedData((prev) => ({
                          ...prev,
                          issuerId: previousData.issuer?.id || null,
                          investorDividendTypeId: previousData.investorDividendType?.id || null,
                          claimType: previousData.claimType || null,
                          accountType: previousData.accountType || null,
                          isSuspense: previousData.isSuspense,
                          dividendStatus: previousData.dividendStatus,
                          applicationDate: previousData.applicationDate || null,
                          receiveDate: previousData.receiveDate || null,
                          remarks: previousData.remarks || null,
                          settelementDetails: settlementDetails,
                          p_suspense_amount: previousData.totalSuspenseAmount ?? totals.totalSuspenseAmount,
                          p_totalamount: previousData.totalAmount ?? totals.totalAmount,
                        }));
                        setEnableEdit(false);
                      }}>
                       <CancelIcon/> Cancel
                      </Button>
                      <Button variant="contained" size="small" style={{padding:"1px 5px",fontSize:"12px"}} onClick={()=>handleUpdateChange()}>
                       <SaveAsIcon/> Update Changes
                      </Button>
                      </> 
                      : 
                      <Button variant="contained" size="small" 
                      onClick={()=>handleEditOpen()} 
                      style={{
                        padding:"1px 5px",
                        fontSize:"12px",
                        }}
                      >
                        <BorderColorIcon /> Edit
                      </Button>
                    }
                  </StyledTableCell>
                </StyledTableRow>
                :
                null
                }
                
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>);

export default InvestorInformationSection;
